import { useMemo } from 'react';

import type { TenantTeamMember, TenantTeamView } from '@ndvr/auth-api';

import { allTenantTeamMembers, useTenantTeamQuery } from 'views/admin/tenantTeam/tenant-team-queries';

export type TaskAssigneeMember = TenantTeamMember & { internalUserGUID: string };

export const useTaskAssigneeMembers = (tenantGUID?: string) => {
    const query = useTenantTeamQuery(tenantGUID);
    const members = useMemo(() => mergeTenantTeamMembers(query.data), [query.data]);

    return { ...query, data: members };
};

export const mergeTenantTeamMembers = (team?: TenantTeamView): TaskAssigneeMember[] => {
    const memberByGUID = new Map<string, TaskAssigneeMember>();

    allTenantTeamMembers(team).forEach((member) => {
        if (!member.internalUserGUID || memberByGUID.has(member.internalUserGUID)) {
            return;
        }
        memberByGUID.set(member.internalUserGUID, member as TaskAssigneeMember);
    });

    return [...memberByGUID.values()];
};
